module.exports = __webpack_public_path__ + "img/English-12.0ab63549.jpg";